import React from "react";

function Products() {
  return <div>This is products page</div>;
}

export default Products;
